import type { Spot } from '~/features/facets/types'
import type { Facet } from './type'

export function spotIdToFacet(spot: Spot, inSpotOnly?: boolean): Facet {
  return {
    label: `${spot.name}${inSpotOnly ? '' : '周辺'}`,
    facetKey: `spot.${spot.id}`,
    add(current) {
      // サジェストAPIがスポットIDを返すようになり、UI上からスポットIDを指定できるようになったら、
      // KeywordToFacet と同様にここでエリア情報を削除する必要がある
      return current ?? {}
    },
    remove(current) {
      // spot を検索条件から外す際は、 spot に付随する radius と aroundHotel を一緒に削除する
      const { spotId, radius, aroundHotel, ...removed } = current ?? {}
      return removed
    },
    selected(criteria) {
      return criteria?.spotId === spot.id
    },
    showInList(criteria) {
      return this.selected(criteria)
    },
  }
}
